import * as _ from "underscore";

// Models
import { NavigationMenuResponse } from "Content/ts/Models/Shared/Navigation/MainMenu/MainMenuDetails";
import { MappedNavigationDetails } from "Content/ts/Models/Shared/Navigation/MainMenu/MappedNavigationDetails";

export module ConfigureNavigationMenuService {
    export function BuildNavigationMenu(menuItems: Array<NavigationMenuResponse>): Array<MappedNavigationDetails> {
        return _.map(menuItems, (menuItem: NavigationMenuResponse, index: number) => {
            const subMenuIdentifier = `main-navigation-submenu-${index}`;

            let mappedMenuItem = {
                Url: menuItem.Url,
                Name: menuItem.Name,
                Icon: `${menuItem.Icon} fa-fw`,
                IsEnabled: menuItem.IsEnabled,
                HasIcon: menuItem.Icon != null,
                SubMenuIdentifier: subMenuIdentifier,
                DataTargetValue: `#${subMenuIdentifier}`,

                ChildItemsAvailable: AreChildItemsAvailable(menuItem),
                IsActive: AreAnyChildrenSelected(menuItem.MenuItemChildren) || FormatUrl(menuItem.Url) == FormatUrl(window.location.pathname)
            } as MappedNavigationDetails;

            mappedMenuItem.InitialCollapsedState = mappedMenuItem.IsActive ? "" : "collapsed";

            if (menuItem.MenuItemChildren != null && menuItem.MenuItemChildren.length > 0) {
                mappedMenuItem.ChildItems = BuildNavigationMenu(menuItem.MenuItemChildren);
            }

            return mappedMenuItem;
        });
    };

    function AreChildItemsAvailable(menuItem: NavigationMenuResponse): boolean {
        if (menuItem.MenuItemChildren == null || menuItem.MenuItemChildren.length == 0) {
            return false;
        }

        return _.some(menuItem.MenuItemChildren, (childItem: NavigationMenuResponse) => { return childItem.IsEnabled; })
    };

    function AreAnyChildrenSelected(menuItems: Array<NavigationMenuResponse>): boolean {
        return _.any(menuItems, (menuItem: NavigationMenuResponse) => {
            return FormatUrl(menuItem.Url) == FormatUrl(window.location.pathname);
        });
    };

    function FormatUrl(url: string): string {
        if (!url) {
            return null;
        }

        const evaluateUrl = (url ? url : null) as string,
            formattedUrl = evaluateUrl
                .replace(/^\/|\/$/g, '')
                .toLowerCase();

        if (_.contains(formattedUrl, "/personalprofile")) {
            // Purpose  :   Profile has multiple URLs. The URLs are read from the routing setup and
            //              changing that will have knock - on effects.Therefore this is a necessary evil.
            return formattedUrl.replace('/personalprofile', '/account/profile');
        }

        return formattedUrl;
    };
}